import { render, staticRenderFns } from "./AssignedAgentGroupToProject.vue?vue&type=template&id=dea5731e&scoped=true"
import script from "./AssignedAgentGroupToProject.vue?vue&type=script&lang=js"
export * from "./AssignedAgentGroupToProject.vue?vue&type=script&lang=js"
import style0 from "./AssignedAgentGroupToProject.vue?vue&type=style&index=0&id=dea5731e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea5731e",
  null
  
)

export default component.exports